/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { GsGeolocationCity } from '../model/gsGeolocationCity';
import { RestError } from '../model/restError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MtcGsGeolocationControllerService {

    protected basePath = 'https://mtc-ms-backoffice-api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getCityById
     * 
     * @param idCity idCity
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCityByIdUsingGET(idCity: string, observe?: 'body', reportProgress?: boolean): Observable<GsGeolocationCity>;
    public getCityByIdUsingGET(idCity: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GsGeolocationCity>>;
    public getCityByIdUsingGET(idCity: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GsGeolocationCity>>;
    public getCityByIdUsingGET(idCity: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idCity === null || idCity === undefined) {
            throw new Error('Required parameter idCity was null or undefined when calling getCityByIdUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GsGeolocationCity>(`${this.basePath}/geo/city/${encodeURIComponent(String(idCity))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchCityByCountryAndName
     * 
     * @param country country
     * @param cityName cityName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchCityByCountryAndNameUsingGET(country: string, cityName: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GsGeolocationCity>>;
    public searchCityByCountryAndNameUsingGET(country: string, cityName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GsGeolocationCity>>>;
    public searchCityByCountryAndNameUsingGET(country: string, cityName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GsGeolocationCity>>>;
    public searchCityByCountryAndNameUsingGET(country: string, cityName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (country === null || country === undefined) {
            throw new Error('Required parameter country was null or undefined when calling searchCityByCountryAndNameUsingGET.');
        }

        if (cityName === null || cityName === undefined) {
            throw new Error('Required parameter cityName was null or undefined when calling searchCityByCountryAndNameUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<Array<GsGeolocationCity>>(`${this.basePath}/geo/city/${encodeURIComponent(String(country))}/${encodeURIComponent(String(cityName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
